import { render, staticRenderFns } from "./layout-product-tab.vue?vue&type=template&id=2b32b202&scoped=true"
import script from "./layout-product-tab.vue?vue&type=script&lang=js"
export * from "./layout-product-tab.vue?vue&type=script&lang=js"
import style0 from "./layout-product-tab.vue?vue&type=style&index=0&id=2b32b202&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b32b202",
  null
  
)

export default component.exports